if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

        this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
        this.querySelector('.share-button__copy').addEventListener('click', this.copyToClipboard.bind(this));
        this.elements.closeButton.addEventListener('click', this.close.bind(this));
        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', async () => {
            try {
              await navigator.share({ url: this.urlToShare, title: document.title });
            } catch (error) {
              if (error.name === 'AbortError') return;
              this.elements.shareButton.classList.add('hidden');
              this.mainDetailsToggle.removeAttribute('hidden');
              this.mainDetailsToggle.open = true;
              this.elements.urlInput.focus();
              this.elements.urlInput.select();
            }
          });
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      async copyToClipboard() {
        try {
          await navigator.clipboard.writeText(this.elements.urlInput.value);
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        } catch {
          this.elements.urlInput.focus();
          this.elements.urlInput.select();
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = 'Select and copy the product link to share it.';
        }
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }
    }
  );
}
